// ABOUTME: The glyph of a workout type — one place for the WorkoutType → icon mapping that lists and cards used to repeat.
// ABOUTME: Size flows to the glyph; a type outside the enum (bad data) falls back to the "other" glyph.

import type { FC } from "react"
import { WorkoutType } from "@/graphql/main/gql/graphql"
import { BikeIcon } from "./BikeIcon"
import { OtherIcon } from "./OtherIcon"
import { RunIcon } from "./RunIcon"
import { SkiIcon } from "./SkiIcon"
import { StrengthIcon } from "./StrengthIcon"
import { SwimIcon } from "./SwimIcon"
import { WalkIcon } from "./WalkIcon"

type Glyph = FC<{ width?: number; height?: number }>

const GLYPHS: Record<WorkoutType, Glyph> = {
  [WorkoutType.Running]: RunIcon,
  [WorkoutType.Walk]: WalkIcon,
  [WorkoutType.Swim]: SwimIcon,
  [WorkoutType.Bike]: BikeIcon,
  [WorkoutType.Strength]: StrengthIcon,
  [WorkoutType.Other]: OtherIcon,
  [WorkoutType.Ski]: SkiIcon,
}

export interface SportIconProps {
  type: WorkoutType
  width?: number
  height?: number
}

export const SportIcon: FC<SportIconProps> = ({ type, width, height }) => {
  const Glyph = Object.hasOwn(GLYPHS, type) ? GLYPHS[type] : OtherIcon
  return (
    <Glyph
      width={width}
      height={height}
    />
  )
}
